define('CCTFullBanner.View', [
	'awalabs_cmsfullbanner_cctfullbanner.tpl',
	'CustomContentType.Base.View',
	'jQuery',
	'SC.Configuration'
], function CCTFullBannerView(
	awalabsCmsfullbannerCctfullbannerTpl,
	CustomContentTypeBaseView,
	jQuery,
	Configuration
) {
	'use strict';

	return CustomContentTypeBaseView.extend({
		template: awalabsCmsfullbannerCctfullbannerTpl,
		install: function install(settings, contextData) {
			this._install(settings, contextData);
			return jQuery.Deferred().resolve();
		},
		getContext: function getContext() {
			var siteUrl = Configuration.siteSettings.touchpoints.home;
			var parsedTitle = jQuery.parseHTML(this.settings.custrecord_awa_cct_fullbanner_title); // If title needs <br> or any html

			return {
				bgImage: siteUrl + '/' + this.settings.custrecord_awa_cct_fullbanner_bgimage,
				dtImage: siteUrl + '/' + this.settings.custrecord_awa_cct_fullbanner_leftimage,
				mbImage: siteUrl + '/' + this.settings.custrecord_awa_cct_fullbanner_rightimage,
				textSize: parsedTitle[0] && parsedTitle[0].data && parsedTitle[0].data.length > 28 ? 'medium' : 'big',
				title: parsedTitle[0] && parsedTitle[0].data ? parsedTitle[0].data : ''
			};
		}
	});
});
